import { Component, Input, trigger, state, style,
  transition, animate } from '@angular/core';

import {Person} from '../../model/person';
import {SterbefallProvider} from "../../providers/sterbefall.provider";


@Component({
  selector: 'elternteil-panel',
  templateUrl: 'elternteil-panel.html',
  animations: [
    trigger('animState', [
      state('true', style({
        height: '0px',
        display: 'none'
      })),
      state('false', style({
        height: '*',
        display: 'block'
      })),
      transition('* => *', animate('300ms ease-in')),
      //transition('true => false', animate('300ms ease-out'))
    ])
  ]
})
export class ElternteilPanel {

  @Input() typ: string = "?";
  @Input() elternteil: Person;

  constructor(private sterbefallProvider : SterbefallProvider) {
  }

  copyVerstorbenerAnschrift() : void {
    let s = this.sterbefallProvider.aktuellerSterbefall;
    this.elternteil.plz = s.verstorbener.plz;
    this.elternteil.ort = s.verstorbener.ort;
    this.elternteil.strasse = s.verstorbener.strasse;
  }

  copyPartnerAnschrift() : void {
    let s = this.sterbefallProvider.aktuellerSterbefall;
    let partner = (this.typ == "Vater" ? s.mutter : s.vater);
    if (partner != null) {
      this.elternteil.plz = partner.plz;
      this.elternteil.ort = partner.ort;
      this.elternteil.strasse = partner.strasse;
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/elternteil-panel/elternteil-panel.component.ts